import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import ArchitectsModal from '../components/ArchitectsModal';
import PrivateModal from '../components/PrivateModal';
import AluminumSystemsModal from '../components/AluminumSystemsModal';
import CompanyModal from '../components/CompanyModal';
import ContactModal from '../components/ContactModal';
import { useLanguage } from '../i18n/LanguageContext';

const ESPA_LOGO = 'https://customer-assets-rejwkqb3.emergentagent.net/job_bb24eabe-6ef2-4d89-a7b7-511a398af039/artifacts/awxg4lzk_antagonistikotitaframeEL.jpg';

const Home = () => {
  const [showLogo, setShowLogo] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const navigate = useNavigate();
  const { t, lang, toggleLang } = useLanguage();

  useEffect(() => {
    setTimeout(() => setShowLogo(true), 100);
    setTimeout(() => setShowContent(true), 1500);
  }, []);

  const openModal = (modalName) => {
    setActiveModal(modalName);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setActiveModal(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="home-container">
      <a href="#main-content" className="skip-link">{t('home.skip')}</a>

      {/* Language toggle */}
      <button
        className="lang-toggle"
        onClick={toggleLang}
        aria-label={lang === 'el' ? 'Switch to English' : 'Αλλαγή στα Ελληνικά'}
        data-testid="lang-toggle"
      >
        <span className="lang-flag" aria-hidden="true">
          {lang === 'el' ? '🇬🇧' : '🇬🇷'}
        </span>
        <span className="lang-label">{lang === 'el' ? 'EN' : 'EL'}</span>
      </button>

      {/* Background */}
      <div className="background-wrapper" aria-hidden="true">
        <div className="background-image"></div>
        <div className={`background-overlay ${activeModal ? 'lighter' : ''}`}></div>
      </div>

      {/* Main Content */}
      <main id="main-content" className="main-content">
        <div className={`logo-container ${showLogo ? 'show' : ''}`}>
          <div className="logo-circle">
            <img
              src="https://customer-assets.emergentagent.com/job_bb24eabe-6ef2-4d89-a7b7-511a398af039/artifacts/wea2b3ng_1000023447.png"
              alt="QALS Logo"
              className="logo-image"
            />
          </div>
        </div>

        <div className={`title-wrapper ${showContent ? 'show' : ''}`}>
          <div className="title-border top" aria-hidden="true"></div>
          <h1 className="main-title">{t('home.title')}</h1>
          <p className="subtitle">{t('home.subtitle')}</p>
          <div className="title-border bottom" aria-hidden="true"></div>
        </div>

        <nav className={`main-nav ${showContent ? 'show' : ''}`} aria-label="Main navigation">
          <button className="nav-button" onClick={() => openModal('architects')} data-testid="nav-architects">
            {t('nav.architects')}
          </button>
          <button className="nav-button" onClick={() => openModal('private')} data-testid="nav-private">
            {t('nav.private')}
          </button>
          <button className="nav-button" onClick={() => openModal('aluminum')} data-testid="nav-aluminum">
            {t('nav.aluminum')}
          </button>
          <button className="nav-button" onClick={() => openModal('company')} data-testid="nav-company">
            {t('nav.company')}
          </button>
          <button className="nav-button" onClick={() => openModal('contact')} data-testid="nav-contact">
            {t('nav.contact')}
          </button>
        </nav>
      </main>

      {/* ESPA footer bar */}
      <button
        className="espa-footer"
        onClick={() => navigate('/espa')}
        aria-label={t('espa.title')}
        data-testid="espa-footer"
      >
        <img src={ESPA_LOGO} alt="ΕΣΠΑ 2021-2027" className="espa-footer__image" />
      </button>

      {/* Modals */}
      {activeModal === 'architects' && <ArchitectsModal onClose={closeModal} />}
      {activeModal === 'private' && <PrivateModal onClose={closeModal} />}
      {activeModal === 'aluminum' && <AluminumSystemsModal onClose={closeModal} />}
      {activeModal === 'company' && <CompanyModal onClose={closeModal} />}
      {activeModal === 'contact' && <ContactModal onClose={closeModal} />}
    </div>
  );
};

export default Home;
